import { createActionGroup, props } from '@ngrx/store';

export const AppActions = createActionGroup({
  source: 'App',
  events: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'Display Error': props<{ payload?: any }>(),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'Display Success Message': props<{ payload: any }>(),
    'Download Blob': props<{ blob: Blob; fileName: string }>(),
  },
});
